<script setup>
import { computed } from 'vue';

const props = defineProps({
  reactions: { type: Array, default: () => [] },
});

const groupedReactions = computed(() => {
  const groups = new Map();

  props.reactions.forEach(reaction => {
    if (!reaction?.emoji) return;

    const existing = groups.get(reaction.emoji);
    if (existing) {
      existing.count += 1;
      return;
    }

    groups.set(reaction.emoji, { emoji: reaction.emoji, count: 1 });
  });

  return Array.from(groups.values());
});
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div
    v-if="groupedReactions.length"
    class="pointer-events-none absolute -bottom-2 ltr:left-2 rtl:right-2 z-10 flex min-h-6 items-center gap-0.5 rounded-full border border-n-slate-5 bg-n-surface-1 px-1.5 py-0 shadow-sm"
  >
    <span
      v-for="reaction in groupedReactions"
      :key="reaction.emoji"
      class="inline-flex items-center text-xs leading-4"
    >
      <span>{{ reaction.emoji }}</span>
      <span v-if="reaction.count > 1" class="ml-0.5 text-n-slate-11">
        {{ reaction.count }}
      </span>
    </span>
  </div>
</template>
